document.addEventListener('DOMContentLoaded',function(){var productUrl='/products/avenlo-rippleguard%E2%84%A2-10l-splash-proof-dog-water-bowl';function relabel(){document.querySelectorAll('.menu-list__link,.menu-drawer__menu-item').forEach(function(link){if(link.textContent.trim()==='Catalog'){link.textContent='Product';link.setAttribute('href',productUrl)}})}relabel();new MutationObserver(relabel).observe(document.body,{childList:true,subtree:true})});

document.addEventListener('DOMContentLoaded',function(){
  var timer=document.querySelector('[data-avenloo-countdown]');
  if(!timer)return;
  var duration=2*60*60*1000;
  var storageKey='avenloo-offer-countdown-end';
  var end;
  try{end=Number(window.localStorage.getItem(storageKey))||0}catch(error){end=0}
  function save(value){try{window.localStorage.setItem(storageKey,String(value))}catch(error){}}
  function update(){
    var now=Date.now();
    if(!end||end<=now){
      end=end||now+duration;
      while(end<=now)end+=duration;
      save(end);
    }
    var remaining=end-now;
    var hours=Math.floor(remaining/3600000);
    var minutes=Math.floor((remaining%3600000)/60000);
    var seconds=Math.floor((remaining%60000)/1000);
    timer.querySelector('[data-countdown-hours]').textContent=String(hours).padStart(2,'0');
    timer.querySelector('[data-countdown-minutes]').textContent=String(minutes).padStart(2,'0');
    timer.querySelector('[data-countdown-seconds]').textContent=String(seconds).padStart(2,'0');
  }
  update();
  window.setInterval(update,1000);
});
